module.exports = __webpack_public_path__ + "static/media/residuos.ff003318.jpg";